import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { trpcClient } from '@/lib/trpc-client'
import type { UserCriteria } from '@/lib/schema'

interface CriteriaState {
  criteria: UserCriteria | null
  isLoading: boolean
  error: string | null
}

interface CriteriaActions {
  fetchCriteria: () => Promise<void>
  updateCriteria: (updates: UserCriteria) => Promise<void>
  reset: () => void
}

const initialState: CriteriaState = {
  criteria: null,
  isLoading: false,
  error: null,
}

export const useCriteriaStore = create<CriteriaState & CriteriaActions>()(
  persist(
    (set) => ({
      ...initialState,

      fetchCriteria: async () => {
        set({ isLoading: true, error: null })
        try {
          const { criteria } = await trpcClient.criteria.get.query()
          set({ criteria, isLoading: false })
        } catch (error) {
          set({ error: (error as Error).message, isLoading: false })
          throw error
        }
      },

      updateCriteria: async (updates: UserCriteria) => {
        set({ isLoading: true, error: null })
        try {
          const { criteria } = await trpcClient.criteria.update.mutate(updates)
          set({ criteria, isLoading: false })
        } catch (error) {
          set({ error: (error as Error).message, isLoading: false })
          throw error
        }
      },

      reset: () => {
        set(initialState)
      },
    }),
    {
      name: 'underwriter-criteria',
      partialize: (state) => ({ criteria: state.criteria }),
    }
  )
)
